import Env from '../base/env.js'
import hoverintent from 'hoverintent'

export default class Subnav
{
  constructor()
  {
    if(Env.$mainNav == null) {
      return false
    }
    this.view = Env.$mainNav
    this.$triggers = this.view.querySelectorAll('.jsTrigger-subnav')
    this.$receptors = this.view.querySelectorAll('.jsReceptor')
    this.$triggersExit = this.view.querySelectorAll('.jsTrigger-exit')
    // Fns
    this.setup()
    this.events()
  }

  events()
  {

     const opts = {
        timeout: 500,
        interval: 50
      };



    for(let $trigger of this.$triggers) {

      if(Env.mobileCSS == false) {

        const $subnav = $trigger.querySelector('.jsReceptor')
        hoverintent($trigger,
          ()=> {
            if($subnav.classList.contains('is-active') == false) {
              Env.$html.classList.add('subnav-isOpened')
              $subnav.classList.add('is-active')
              $trigger.classList.add('is-active')
            }
          }, function() {

          })
        .options(opts);;

        hoverintent($subnav,
          ()=> {

          }, function() {
            if($subnav.classList.contains('is-active') == true) {
              Env.$html.classList.remove('subnav-isOpened')
              $subnav.classList.remove('is-active')
              $trigger.classList.remove('is-active')
            }
          })
        .options(opts);;
      }

    //   $trigger.addEventListener('mouseenter',(e)=>{
    //     const $subnav = $trigger.querySelector('.jsReceptor')

    //     if($subnav.classList.contains('is-active') == false) {
    //       Env.$html.classList.add('subnav-isOpened')
    //       $subnav.classList.add('is-active')
    //     }
    //     $subnav.addEventListener('mouseleave',()=>{
    //       if($subnav.classList.contains('is-active') == true) {
    //         Env.$html.classList.remove('subnav-isOpened')
    //         $subnav.classList.remove('is-active')
    //       }
    //     })
    //     e.preventDefault()
    //   })

      if(Env.mobileCSS == true) {
        const $getLink = $trigger.querySelector('.jsLink')
        $getLink.setAttribute('href','#')
        $trigger.addEventListener('click',(e)=>{
          const $subnav = $trigger.querySelector('.jsReceptor')
          $subnav.classList.toggle('is-active')
          e.preventDefault()
          return false;
        })
      }
    }
    for(let $trigger of this.$triggersExit) {

      hoverintent($trigger,
        ()=> {
          Env.$html.classList.remove('subnav-isOpened')
          for(let $subnav of this.$receptors) {
            $subnav.classList.remove('is-active')
            $subnav.parentElement.classList.remove('is-active')
          }
        }, function() {

        })
      .options(opts);;
      // $trigger.addEventListener('mouseenter',(e)=>{
      //   Env.$html.classList.remove('subnav-isOpened')
      //   for(let $subnav of this.$receptors) {
      //     $subnav.classList.remove('is-active')
      //   }
      // })
    }
  }

  setup()
  {
    let i = 1;
    for(let $subnav of this.$receptors) {
      const coord = $subnav.getBoundingClientRect()
      document.documentElement.style.setProperty(`--menu-height-open-${i}`, `${coord.height}px`)
      $subnav.classList.add('can-toggle')
      i++
    }
  }
}
